const MK_TWELVE_WEEKS_5999_TWELVE_WEEKS_3499_INTRO_PLAN = 'mkTwelveWeeks5999TwelveWeeks3499Intro';
const MK_FOUR_WEEKS_2999_FOUR_WEEKS_1999_INTRO_PLAN = 'mkFourWeeks2999FourWeeks1999Intro';
const MK_TWELVE_WEEKS_5999_WITHOUT_TRIAL_PLAN = 'mkTwelveWeeks5999WithoutTrial';
const MK_FOUR_WEEKS_2999_WITHOUT_TRIAL_PLAN = 'mkFourWeeks2999WithoutTrial';
const MK_FOUR_WEEKS_2999_ONE_WEEK_899_TRIAL_PLAN = 'mkFourWeeks2999OneWeek899Trial';

export {
    MK_TWELVE_WEEKS_5999_TWELVE_WEEKS_3499_INTRO_PLAN,
    MK_FOUR_WEEKS_2999_FOUR_WEEKS_1999_INTRO_PLAN,
    MK_TWELVE_WEEKS_5999_WITHOUT_TRIAL_PLAN,
    MK_FOUR_WEEKS_2999_WITHOUT_TRIAL_PLAN,
    MK_FOUR_WEEKS_2999_ONE_WEEK_899_TRIAL_PLAN
};
